import * as Constants from '../constants/statsbar';

const initialState = {
  activeComponent: '',
  activeComponentOptions: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.SET_ACTIVE_COMPONENT:
      return {
        ...state,
        activeComponent: action.activeComponent,
        activeComponentOptions: action.options,
      };

    case Constants.CLEAR_ACTIVE_COMPONENT_OPTIONS:
      return {
        ...state,
        activeComponentOptions: {},
      };

    default:
      return state;
  }
};
